/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamJoinCreateDialogQueryVariables = {
    orgRelayId: string;
    myCalendarIds: Array<string>;
    excludeMyTeams?: boolean | null | undefined;
};
export type TeamJoinCreateDialogQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"TeamJoinCreate_viewer">;
    };
};
export type TeamJoinCreateDialogQuery = {
    readonly response: TeamJoinCreateDialogQueryResponse;
    readonly variables: TeamJoinCreateDialogQueryVariables;
};



/*
query TeamJoinCreateDialogQuery(
  $orgRelayId: ID!
  $myCalendarIds: [String!]!
  $excludeMyTeams: Boolean
) {
  viewer {
    ...TeamJoinCreate_viewer_2HkqcA
    id
  }
}

fragment AvatarPerson_orgPerson on OrgPerson {
  __typename
  id
  primaryCalendarId
  isYou
  userId
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment TeamJoinCreate_viewer_2HkqcA on Viewer {
  ...TeamSettingsSearch_viewer_YNSM7
  user {
    id
  }
  id
  teamQueryResultErrorable(query: "", orgRelayId: $orgRelayId, excludeMyTeams: $excludeMyTeams) {
    __typename
    ... on TeamQueryResult {
      query
      teams {
        teamName
        teamId
        teamRoleAndPersonIds {
          role
          personId
        }
        id
      }
      teamMembers {
        role
        person {
          ...AvatarPerson_orgPerson
          personId
          primaryCalendarId
          isYou
          profile {
            givenName
            familyName
          }
          id
        }
      }
    }
  }
}

fragment TeamSettingsSearch_viewer_YNSM7 on Viewer {
  orgPersonQueryResultErrorable(query: "", orgRelayId: $orgRelayId, excludeCalendars: $myCalendarIds) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on OrgPersonQueryResult {
      query
      persons {
        ...AvatarPerson_orgPerson
        userId
        personId
        primaryCalendarId
        calendarAliases
        redirectPersonId
        isYou
        profile {
          givenName
          familyName
          externalImageUrl
        }
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeMyTeams"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "myCalendarIds"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v3 = {
        "kind": "Variable",
        "name": "excludeMyTeams",
        "variableName": "excludeMyTeams"
    } as any, v4 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v5 = {
        "kind": "Literal",
        "name": "query",
        "value": ""
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "query",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "TeamJoinCreateDialogQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v3 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "myCalendarIds",
                                    "variableName": "myCalendarIds"
                                },
                                (v4 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "TeamJoinCreate_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "TeamJoinCreateDialogQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "excludeCalendars",
                                    "variableName": "myCalendarIds"
                                },
                                (v4 /*: any*/),
                                (v5 /*: any*/)
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "orgPersonQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "statusCode",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "message",
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "GraphEntityError",
                                    "abstractKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v7 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgPerson",
                                            "kind": "LinkedField",
                                            "name": "persons",
                                            "plural": true,
                                            "selections": [
                                                (v6 /*: any*/),
                                                (v8 /*: any*/),
                                                (v9 /*: any*/),
                                                (v10 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v13 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "calendarAliases",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "redirectPersonId",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "OrgPersonQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v8 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v8 /*: any*/),
                        {
                            "alias": null,
                            "args": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/)
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "teamQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v7 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Team",
                                            "kind": "LinkedField",
                                            "name": "teams",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "teamName",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "teamId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TeamRoleAndPersonId",
                                                    "kind": "LinkedField",
                                                    "name": "teamRoleAndPersonIds",
                                                    "plural": true,
                                                    "selections": [
                                                        (v14 /*: any*/),
                                                        (v13 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v8 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TeamMember",
                                            "kind": "LinkedField",
                                            "name": "teamMembers",
                                            "plural": true,
                                            "selections": [
                                                (v14 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "OrgPerson",
                                                    "kind": "LinkedField",
                                                    "name": "person",
                                                    "plural": false,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v13 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "TeamQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "26857ab03ea4a15387084af13e5522d5",
            "id": null,
            "metadata": {},
            "name": "TeamJoinCreateDialogQuery",
            "operationKind": "query",
            "text": "query TeamJoinCreateDialogQuery(\n  $orgRelayId: ID!\n  $myCalendarIds: [String!]!\n  $excludeMyTeams: Boolean\n) {\n  viewer {\n    ...TeamJoinCreate_viewer_2HkqcA\n    id\n  }\n}\n\nfragment AvatarPerson_orgPerson on OrgPerson {\n  __typename\n  id\n  primaryCalendarId\n  isYou\n  userId\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment TeamJoinCreate_viewer_2HkqcA on Viewer {\n  ...TeamSettingsSearch_viewer_YNSM7\n  user {\n    id\n  }\n  id\n  teamQueryResultErrorable(query: \"\", orgRelayId: $orgRelayId, excludeMyTeams: $excludeMyTeams) {\n    __typename\n    ... on TeamQueryResult {\n      query\n      teams {\n        teamName\n        teamId\n        teamRoleAndPersonIds {\n          role\n          personId\n        }\n        id\n      }\n      teamMembers {\n        role\n        person {\n          ...AvatarPerson_orgPerson\n          personId\n          primaryCalendarId\n          isYou\n          profile {\n            givenName\n            familyName\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TeamSettingsSearch_viewer_YNSM7 on Viewer {\n  orgPersonQueryResultErrorable(query: \"\", orgRelayId: $orgRelayId, excludeCalendars: $myCalendarIds) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on OrgPersonQueryResult {\n      query\n      persons {\n        ...AvatarPerson_orgPerson\n        userId\n        personId\n        primaryCalendarId\n        calendarAliases\n        redirectPersonId\n        isYou\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '83d501fff3ad1a6609cd1f48798a367f';
export default node;
